import { useMemo, useState } from "react";
import {
  AgentDetailDialog,
  BuyAgentDialog,
  BuyNoticeDialog,
} from "@/components/modal/home";
import { AgentMarketSection } from "@/components/home/AgentMarketSection";
import { useFortAgentSkuConfig } from "@/hooks/api/useFortAgentSkuConfig";
import { FortAgentSkuConfigItem } from "@/api/types";
import { useUserStore } from "@/store/useUserStore";
import { useNavigate } from "react-router";

export default function Market() {
  const navigate = useNavigate();
  const { userInfo } = useUserStore();
  const isEmailAuth = userInfo?.authType === "email";
  const [buyAgent, setBuyAgent] = useState<FortAgentSkuConfigItem | null>(null);
  const [detailAgent, setDetailAgent] = useState<FortAgentSkuConfigItem | null>(
    null
  );
  const [buyNoticeOpen, setBuyNoticeOpen] = useState(false);
  const { data: skuConfig, isLoading: skuLoading } = useFortAgentSkuConfig();

  const { marketSoldTotal, marketSupplyCap, soldPct } = useMemo(() => {
    const skus = skuConfig?.skus ?? [];
    let sold = 0;
    let cap = 0;
    for (const s of skus) {
      sold += +s.supplyCap - +s.leftSupplyCount;
      cap += s.supplyCap ?? 0;
    }
    const pct = cap > 0 ? (sold / cap) * 100 : 0;
    return {
      marketSoldTotal: sold,
      marketSupplyCap: cap,
      soldPct: pct,
    };
  }, [skuConfig?.skus]);

  return (
    <div className="pt-top-header-relaxed pb-24 px-4 max-w-lg mx-auto page-enter">
      <AgentMarketSection
        variant="standalone"
        skuLoading={skuLoading}
        skus={skuConfig?.skus}
        marketSoldTotal={marketSoldTotal}
        marketSupplyCap={marketSupplyCap}
        soldPct={soldPct}
        onOpenBuyNotice={() => setBuyNoticeOpen(true)}
        buyDisabled={isEmailAuth}
        onBuy={agent => {
          if (!userInfo) {
            navigate("/login");
            return;
          }
          setBuyAgent(agent);
        }}
        onDetail={agent => setDetailAgent(agent)}
      />

      <BuyAgentDialog
        agent={buyAgent}
        open={!!buyAgent}
        onClose={() => setBuyAgent(null)}
        canMix={userInfo?.canMix ?? false}
      />
      <AgentDetailDialog
        agent={detailAgent}
        open={!!detailAgent}
        onClose={() => setDetailAgent(null)}
      />
      <BuyNoticeDialog
        open={buyNoticeOpen}
        onClose={() => setBuyNoticeOpen(false)}
      />
    </div>
  );
}
